__turbopack_context__.v({
  "answers": "CsatSurvey-module-scss-module__XAuLwG__answers",
  "dismiss-button": "CsatSurvey-module-scss-module__XAuLwG__dismiss-button",
  "prompt": "CsatSurvey-module-scss-module__XAuLwG__prompt",
  "wrapper": "CsatSurvey-module-scss-module__XAuLwG__wrapper",
});
